import { CommonContainer } from '@/styles/Qstyle';
import * as S from './styles';
import RewardHeader from './RewardHeader';
import RewardContent from './RewardContent';
import { RewardAnimation } from './RewardAnimation';
import { useRewardAnimation } from './useRewardAnimation';

export const RewardPage = () => {
  const { isAnimationVisible, rewardInfo, hideAnimation } =
    useRewardAnimation();

  return (
    <CommonContainer>
      <S.WrapperContainer>
        <RewardHeader />
        <RewardContent />
      </S.WrapperContainer>
      <RewardAnimation
        isVisible={isAnimationVisible}
        rewardInfo={rewardInfo}
        onComplete={hideAnimation}
      />
    </CommonContainer>
  );
};
